import { useMemo, type ReactNode } from 'react';
import { resolveReportColorPalette } from '@erp/shared-types';
import { useReportColorPalettes } from '@/api/rpc/hooks/report-color-palettes/useReportColorPalettes';
import { ReportColorPaletteContext } from './ReportColorPaletteContext';

/**
 * Gives a report canvas the colors it draws with: the palette `paletteId`
 * names, else the organization's default, else the built-in one (also while
 * the organization's palettes load).
 */
export function ReportColorPaletteProvider({
  paletteId,
  children,
}: {
  paletteId?: string;
  children: ReactNode;
}) {
  const { data } = useReportColorPalettes();
  const colors = useMemo(
    () => resolveReportColorPalette(data ?? [], paletteId),
    [data, paletteId],
  );
  return (
    <ReportColorPaletteContext.Provider value={colors}>
      {children}
    </ReportColorPaletteContext.Provider>
  );
}
